import * as React from "react";

export function AgentCommerceStory() {
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="font-sans text-2xl font-semibold leading-tight text-default">
          One place to build and grow your business
        </h2>
        <p className="max-w-[430px] text-sm leading-relaxed text-default">
          Build your site, launch campaigns, and manage the day-to-day all in
          one tool.
        </p>
      </div>
    </div>
  );
}
